// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3IvRB";
var _4 = "totalRefund-2zxr9";
var _5 = "priceHeadTitle-3yuxD";
var _6 = "retentionPriceDetails-3iBQk";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "totalRefund", _5 as "priceHeadTitle", _6 as "retentionPriceDetails" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "totalRefund": _4, "priceHeadTitle": _5, "retentionPriceDetails": _6 }
